module.exports = __webpack_public_path__ + "static/media/ComicSansMS.10a2a1f5.woff";